/**
 * Fields required to hydrate the authenticated user from the `/me` endpoint.
 *
 * Nested relation key fields are included so RStore can cache the included
 * `orgRole` and `role` objects instead of receiving keyless relation payloads.
 */
const CURRENT_USER_FIELDS = [
	'id',
	'email',
	'fullName',
	'avatarId',
	'appearance',
	'authLinks.providerId',
	'orgRole.userId',
	'orgRole.orgRoleId',
	'orgRole.role.id',
	'orgRole.role.isAdmin',
] as const;

/**
 * Comma-separated field selection for the authenticated user request.
 */
export const CURRENT_USER_FIELDS_QUERY = CURRENT_USER_FIELDS.join(',');
